import { render, staticRenderFns } from "./GenerateReportCards.vue?vue&type=template&id=6521f220&scoped=true"
import script from "./GenerateReportCards.vue?vue&type=script&lang=js"
export * from "./GenerateReportCards.vue?vue&type=script&lang=js"
import style0 from "./GenerateReportCards.vue?vue&type=style&index=0&id=6521f220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521f220",
  null
  
)

export default component.exports